module.exports = __webpack_public_path__ + "media/images/companyPage/communication-a2dc4f2e5b25f6ce05a5d9d8e024db87.svg";